"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledContentBody = exports.StyledContentTitle = exports.StyledContent = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _themes = require("../../style/themes");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledContent = _styledComponents.default.div`
  ${({
  bodyFullWidth,
  align
}) => (0, _styledComponents.css)`
    ${_styledSystem.margin}

    & + & {
      margin-top: 15px;
    }

    ${align && (0, _styledComponents.css)`
      text-align: ${align};
    `}
    ${bodyFullWidth && (0, _styledComponents.css)`
      text-align: left;
    `}
  `}
`;
exports.StyledContent = StyledContent;
StyledContent.defaultProps = {
  theme: _themes.baseTheme
};
const StyledContentTitle = _styledComponents.default.div`
  ${({
  theme,
  titleWidth,
  inline,
  variant,
  align
}) => {
  return (0, _styledComponents.css)`
      display: ${inline ? "inline-block" : "block"};
      font-weight: bold;
      color: ${theme.text.colors};
      width: ${titleWidth && `calc(${titleWidth}% - 30px)`};
      text-align: ${!inline && align};

      ${align === "center" && inline && (0, _styledComponents.css)`
        text-align: right;
        width: calc(50% - 30px);
      `}

      ${variant === "secondary" && (0, _styledComponents.css)`
        color: ${theme.content.secondaryColor};
        font-weight: normal;
      `}
    `;
}};
`;
exports.StyledContentTitle = StyledContentTitle;
const StyledContentBody = _styledComponents.default.div`
  ${({
  bodyFullWidth,
  titleWidth,
  inline,
  align
}) => {
  return (0, _styledComponents.css)`
      display: ${inline ? "inline-block" : "block"};
      margin-top: 2px;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-weight: normal;

      ${align === "center" && inline && (0, _styledComponents.css)`
        width: 50%;
      `}
      ${titleWidth && (0, _styledComponents.css)`
        width: ${100 - Number(titleWidth)}%;
      `}
      ${bodyFullWidth && (0, _styledComponents.css)`
        width: 100%;
      `}

      ${inline && bodyFullWidth && (0, _styledComponents.css)`
        margin-top: 15px;
      `}
      
      ${inline && !bodyFullWidth && (0, _styledComponents.css)`
        margin-top: 0;
        margin-left: 30px;
        text-align: left;
      `}
    `;
}};
`;
exports.StyledContentBody = StyledContentBody;
StyledContentTitle.defaultProps = {
  theme: _themes.baseTheme
};